export default __webpack_public_path__ + "static/logo RC kwadrat-0541c967081864ce915892cd8f139d13.png";